exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logout {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.logout .logout-notice {\n  flex: 0 1 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: 50px;\n  border-radius: 20px;\n  box-shadow: 0px 0px 23px -1px rgba(0,0,0,0.13);\n}\n.logout .logout-notice .logged-out {\n  color: #444;\n  font-size: 25px;\n  margin-bottom: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/Logout.styl
// module id = 1903
// module chunks = 1